"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  createDirectLine: true,
  Components: true,
  hooks: true,
  renderWebChat: true,
  createAdaptiveCardsAttachmentMiddleware: true,
  createCognitiveServicesBingSpeechPonyfillFactory: true,
  createCognitiveServicesSpeechServicesPonyfillFactory: true,
  createStyleSet: true,
  createDirectLineSpeechAdapters: true,
  renderMarkdown: true
};
Object.defineProperty(exports, "createAdaptiveCardsAttachmentMiddleware", {
  enumerable: true,
  get: function get() {
    return _createAdaptiveCardsAttachmentMiddleware.default;
  }
});
Object.defineProperty(exports, "createCognitiveServicesBingSpeechPonyfillFactory", {
  enumerable: true,
  get: function get() {
    return _createCognitiveServicesBingSpeechPonyfillFactory.default;
  }
});
Object.defineProperty(exports, "createCognitiveServicesSpeechServicesPonyfillFactory", {
  enumerable: true,
  get: function get() {
    return _createCognitiveServicesSpeechServicesPonyfillFactory.default;
  }
});
Object.defineProperty(exports, "createStyleSet", {
  enumerable: true,
  get: function get() {
    return _createFullStyleSet.default;
  }
});
Object.defineProperty(exports, "createDirectLineSpeechAdapters", {
  enumerable: true,
  get: function get() {
    return _createDirectLineSpeechAdapters.default;
  }
});
Object.defineProperty(exports, "renderMarkdown", {
  enumerable: true,
  get: function get() {
    return _renderMarkdown.default;
  }
});
exports.renderWebChat = exports.hooks = exports.Components = exports.default = exports.createDirectLine = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _indexMinimal = require("./index-minimal");

Object.keys(_indexMinimal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _indexMinimal[key];
    }
  });
});

var _addVersion = _interopRequireDefault(require("./addVersion"));

var _renderWebChat = _interopRequireDefault(require("./renderWebChat"));

var _createAdaptiveCardsAttachmentMiddleware = _interopRequireDefault(require("./adaptiveCards/createAdaptiveCardsAttachmentMiddleware"));

var _createCognitiveServicesBingSpeechPonyfillFactory = _interopRequireDefault(require("./createCognitiveServicesBingSpeechPonyfillFactory"));

var _createCognitiveServicesSpeechServicesPonyfillFactory = _interopRequireDefault(require("./createCognitiveServicesSpeechServicesPonyfillFactory"));

var _createFullStyleSet = _interopRequireDefault(require("./createFullStyleSet"));

var _createDirectLineSpeechAdapters = _interopRequireDefault(require("./createDirectLineSpeechAdapters"));

var _createDirectLine = _interopRequireDefault(require("./createDirectLine"));

var _FullComposer = _interopRequireDefault(require("./FullComposer"));

var _FullReactWebChat = _interopRequireDefault(require("./FullReactWebChat"));

var _renderMarkdown = _interopRequireDefault(require("./renderMarkdown"));

var _useAdaptiveCardsHostConfig = _interopRequireDefault(require("./adaptiveCards/hooks/useAdaptiveCardsHostConfig"));

var _useAdaptiveCardsPackage = _interopRequireDefault(require("./adaptiveCards/hooks/useAdaptiveCardsPackage"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var renderWebChat = _renderWebChat.default.bind(null, _FullReactWebChat.default);

exports.renderWebChat = renderWebChat;

var createDirectLine = function createDirectLine(options) {
  options.botAgent && console.warn('Web Chat: Developers are not currently allowed to set botAgent. See https://github.com/microsoft/BotFramework-WebChat/issues/2119 for more details.');
  return (0, _createDirectLine.default)(_objectSpread({}, options, {
    botAgent: "WebChat/".concat(_indexMinimal.version, " (Full)")
  }));
};

exports.createDirectLine = createDirectLine;

var patchedHooks = _objectSpread({}, _indexMinimal.hooks, {
  useAdaptiveCardsHostConfig: _useAdaptiveCardsHostConfig.default,
  useAdaptiveCardsPackage: _useAdaptiveCardsPackage.default
});

exports.hooks = patchedHooks;

var Components = _objectSpread({}, _indexMinimal.Components, {
  Composer: _FullComposer.default
});

exports.Components = Components;
var _default = _FullReactWebChat.default;
exports.default = _default;
window['WebChat'] = _objectSpread({}, window['WebChat'], {
  createAdaptiveCardsAttachmentMiddleware: _createAdaptiveCardsAttachmentMiddleware.default,
  createCognitiveServicesBingSpeechPonyfillFactory: _createCognitiveServicesBingSpeechPonyfillFactory.default,
  createCognitiveServicesSpeechServicesPonyfillFactory: _createCognitiveServicesSpeechServicesPonyfillFactory.default,
  createDirectLine: createDirectLine,
  createDirectLineSpeechAdapters: _createDirectLineSpeechAdapters.default,
  createStyleSet: _createFullStyleSet.default,
  hooks: patchedHooks,
  ReactWebChat: _FullReactWebChat.default,
  renderMarkdown: _renderMarkdown.default,
  renderWebChat: renderWebChat
});
(0, _addVersion.default)('full');